import { styled } from '@/styled-system/jsx';

export const CostAndFeesWrapper = styled('div', {
  base: {
    mb: '2x',
    ml: '2x',
    mr: '2x',
  },
});

export const DisclaimerText = styled('div', {
  base: {
    color: 'hpxGrey500',
    cursor: 'pointer',
    fontSize: 'sm',
  },
});

export const LinkContainer = styled('div', {
  base: {
    fontSize: 'md',
    lineHeight: 'sm',
  },
});
